import { BaseDto } from '@up/data';

export class AisTransactionResponseDto extends BaseDto {
  treasuryTransactionTypeId?: number;
  businessEntityId?: number;
  businessEntityBankId?: number;
  account?: string;
  transactionId?: string;
  date: Date;
  source?: string;
  description?: string;
  amount?: number;
  balance?: number;
  amountDirection?: 'CREDIT' | 'DEBIT';
  additionalData?: any;
}
